import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import type { PermissionTemplateRow } from "@/lib/queries";

interface TemplateSelectorProps {
  templates: PermissionTemplateRow[];
  value: string | "none";
  onChange: (templateId: string | null, permissionIds: string[]) => void;
  disabled?: boolean;
}

export function TemplateSelector({ templates, value, onChange, disabled }: TemplateSelectorProps) {
  const selected = templates.find((t) => t.id === value);

  return (
    <div className="space-y-2">
      <Label className="text-xs uppercase tracking-wider text-muted">Template</Label>
      <Select value={value} onValueChange={(v) => {
        if (v === "none") onChange(null, []);
        else {
          const t = templates.find((x) => x.id === v);
          onChange(v, t?.permissionIds ?? []);
        }
      }} disabled={disabled}>
        <SelectTrigger><SelectValue placeholder="Pick a template" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No template</SelectItem>
          {templates.map((t) => (
            <SelectItem key={t.id} value={t.id}>
              {t.name} {t.isSystem && <Badge variant="secondary" className="ml-2 text-[9px]">system</Badge>}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selected && selected.description && (
        <p className="text-xs text-muted">{selected.description}</p>
      )}
      {selected && (
        <p className="text-xs text-muted">Grants {selected.permissionIds.length} permission(s).</p>
      )}
    </div>
  );
}
